<template>
    <div class="loading-message">{{ text }}</div>
</template>

<script>
export default {
    name: 'LoadingMessage',
    props: {
        text: {
            type: String,
            default: 'Загрузка возможностей...',
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.loading-message {
    font-size: urem(16);
    color: rgba(42, 38, 38, 1);
    background: rgba(247, 249, 252, 1);
    padding: urem(12) urem(20);
    line-height: urem(24);
    animation: blink 1s linear infinite;
    cursor: not-allowed;
}

@keyframes blink {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.6;
    }
    100% {
        opacity: 1;
    }
}
</style>
